const FAILURE_TTL_MS = 30 * 60 * 1000

const FAILURE_KEY = 'autologinFailedAt'
const PROCESSED_TOKEN_KEY = 'autologinProcessedToken'

function readStorage(key) {
  try {
    return localStorage.getItem(key)
  } catch {
    return null
  }
}

function writeStorage(key, value) {
  try {
    localStorage.setItem(key, value)
    return true
  } catch {
    return false
  }
}

function removeStorage(key) {
  try {
    localStorage.removeItem(key)
    return true
  } catch {
    return false
  }
}

export function isTokenProcessed(token) {
  return readStorage(PROCESSED_TOKEN_KEY) === token
}

export function markTokenProcessed(token) {
  writeStorage(PROCESSED_TOKEN_KEY, token)
}

export function markAutologinFailure() {
  writeStorage(FAILURE_KEY, String(Date.now()))
}

export function clearAutologinFailure() {
  removeStorage(FAILURE_KEY)
}

export function consumeAutologinFailure() {
  const failedAt = readStorage(FAILURE_KEY)

  if (!failedAt) {
    return false
  }

  removeStorage(FAILURE_KEY)

  return Date.now() - Number(failedAt) < FAILURE_TTL_MS
}
